import apiClient from "@/api/client";

import type {
  AnalyticsFilters,
  AnalyticsOverview,
  AskResult,
  CancelledAnalysis,
  GroupTendersResult,
  MonthlyReport,
  PricingItemsCatalog,
  PricingItemWinrate,
} from "./types";

const BASE = "/power-projects/ze-analytics";

async function unwrap<T>(p: Promise<{ data: { data: T } }>): Promise<T> {
  const r = await p;
  return r.data.data;
}

function toParams(f: AnalyticsFilters): Record<string, string> {
  const p: Record<string, string> = {};
  if (f.from) p.from = f.from;
  if (f.to) p.to = f.to;
  if (f.official_only) p.official_only = "1";
  return p;
}

export const getOverview = (f: AnalyticsFilters = {}) =>
  unwrap<AnalyticsOverview>(apiClient.get(`${BASE}/overview/`, { params: toParams(f) }));

export const getCancelled = (f: AnalyticsFilters = {}) =>
  unwrap<CancelledAnalysis>(apiClient.get(`${BASE}/cancelled/`, { params: toParams(f) }));

export const getGroupTenders = (dimension: string, category: string, f: AnalyticsFilters = {}) =>
  unwrap<GroupTendersResult>(
    apiClient.get(`${BASE}/group-tenders/`, {
      params: { ...toParams(f), dimension, category },
    }),
  );

export const getPricingItems = (f: AnalyticsFilters = {}) =>
  unwrap<PricingItemsCatalog>(apiClient.get(`${BASE}/pricing-items/`, { params: toParams(f) }));

export const getPricingItemWinrate = (item: string, f: AnalyticsFilters = {}) =>
  unwrap<PricingItemWinrate>(
    apiClient.get(`${BASE}/pricing-item-winrate/`, { params: { ...toParams(f), item } }),
  );

export const getMonthly = () =>
  unwrap<MonthlyReport | null>(apiClient.get(`${BASE}/monthly/`));

export const generateMonthly = () =>
  unwrap<{ task_id: string }>(apiClient.post(`${BASE}/monthly/`, {}));

export const askAnalytics = (question: string, f: AnalyticsFilters = {}) =>
  unwrap<AskResult>(apiClient.post(`${BASE}/ask/`, { question, from: f.from, to: f.to }));
